import React from "react";

export default function Slider({
    label,
    min,
    max,
    step,
    value,
    onChange,
    rangeData,
    unit = "",
}) {
    return (
        <>
            {/* Inline CSS for custom slider styling */}
            <style>{`
        .custom-slider {
          height: 4px;
          background-color: gray;
          border-radius: 9999px;
          outline: none;
        }
        .custom-slider::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          height: 18px;
          width: 40px;
          margin-left:0px;
          border-radius: 9999px;
          background: #12F280;
          border: 2px solid white;
          margin-top: 0px;
          cursor: pointer;
        
        }
        .custom-slider::-moz-range-thumb {
          height: 24px;
          width: 48px;
          border-radius: 9999px;
          background: #00ff95;
          border: 2px solid white;
          cursor: pointer;
          
        }
      `}</style>

            <div style={{ fontFamily: "Atkinson-regular" }} className="w-full">
                <div className="flex justify-between items-center">
                    <label className="block  text-[16px] text-[#B3B3B3]">{label}</label>
                    <div  style={{ fontFamily: "Atkinson-regular" }} className="ml-4 px-4 py-2 bg-[#363636] rounded-md text-[16px]  text-[#FFFFFF]">
                        {value.toFixed(2)}{unit}
                    </div>

                </div>
               
                    <div className="relative w-full">
                        <input
                            type="range"
                            min={min}
                            max={max}
                            step={step}
                            value={value}
                            list="values"
                            onChange={(e) => onChange(Number(e.target.value))}
                            className="w-full appearance-none bg-gray-600 custom-slider"
                        />

                        <div className="flex justify-between text-[10px] text-[#3B3B3B] mt-1 px-1">
                            {rangeData.map((val, i) => (
                                <span key={i}>{val}{unit}</span>
                            ))}
                        </div>
                        {/* <datalist id="values">
                 {rangeData.map((val, i) => (
                 <option value={val} label={val}>{unit}</option>
              ))}

            </datalist> */}
                    </div>


                </div>
            
        </>
    );
}
